// Debug: Check if element exists on page load
if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('m-recently-viewed');
    console.log("[Recently Viewed] Found", elements.length, "m-recently-viewed elements on page load");
    elements.forEach((el, index) => {
      console.log("[Recently Viewed] Element", index, ":", el.id, el.className);
    });
  });
}

if (!customElements.get("m-recently-viewed")) {
  class MRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      console.log("[Recently Viewed] Constructor called for element:", this.id || "unknown");
    }

    connectedCallback() {
      console.log("[Recently Viewed] connectedCallback triggered", this.id);
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper", // slideContainer
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.enableSlider = this.dataset.enableSlider === "true";
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.productsPerRow;
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";
      this.productsToshow = parseInt(this.dataset.productsToShow);

      console.log("[Recently Viewed] Initializing with settings:", {
        enableSlider: this.enableSlider,
        productsToShow: this.productsToshow,
        productId: this.dataset.productId
      });

      this.init();
    }

    init() {
      const queryString = this.getQueryString();
      
      // Eğer query string boşsa (localStorage'da ürün yoksa), hiçbir şey yapma
      if (!queryString || queryString.trim() === "") {
        console.log("[Recently Viewed] No products in localStorage, skipping fetch");
        // Element'i gizli tut (zaten m:hidden class'ı var)
        return;
      }
      
      const fullUrl = this.dataset.url + queryString;
      console.log("[Recently Viewed] Fetching products with query:", queryString);
      console.log("[Recently Viewed] Full URL:", fullUrl);
      
      fetch(fullUrl)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("m-recently-viewed");
          if (!recommendations) {
            console.log("[Recently Viewed] No m-recently-viewed element found in response");
            return;
          }
          
          const productCards = recommendations.querySelectorAll(".m-product-card");
          console.log("[Recently Viewed] Found", productCards.length, "products in response");
          
          // İlk ürünün ID'sini kontrol et
          if (productCards.length > 0) {
            const firstCard = productCards[0];
            const firstLink = firstCard.querySelector("a[href*='/products/']");
            if (firstLink) {
              console.log("[Recently Viewed] First product URL:", firstLink.getAttribute("href"));
            }
          }

          // Tek bir scroll container'ı dolduruyoruz (PDP simple-tabs ile aynı yapı).
          // Eski mobile-scroll dual-render kaldırıldı; CSS hem masaüstü hem mobil için
          // m-product-scroll-container'ı stillendiriyor.
          const productsContainer = this.querySelector("[data-products-container]");
          if (productsContainer) {
            const responseContent = recommendations.querySelector("[data-products-container]");
            if (responseContent) {
              productsContainer.innerHTML = responseContent.innerHTML;
            }
          }

          this.products = recommendations.querySelectorAll(".m-product-card").length;
          console.log("[Recently Viewed] Products found:", this.products);
          if (this.products > 0) {
            this.classList.remove("m:hidden");
            console.log("[Recently Viewed] Removed m:hidden class, element should be visible now");
          } else {
            console.log("[Recently Viewed] No products found, keeping element hidden");
          }

          this.initByScreenSize();
          document.addEventListener("matchMobile", () => {
            this.initByScreenSize();
          });
          document.addEventListener("unmatchMobile", () => {
            this.initByScreenSize();
          });

          MinimogTheme.CompareProduct?.setCompareButtonsState();
          MinimogTheme.Wishlist?.setWishlistButtonsState();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer, slideControls } = queryDomNodes(this.selectors, this);

      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        slideControls && slideControls.classList.add("m:hidden");
        slideContainer && slideContainer.classList.remove("swiper-container");
        if (this.swiper) this.swiper.destroy(false, true);
      } else {
        slideControls && slideControls.classList.remove("m:hidden");
        this.initSlider();
      }

      if (this.products <= parseInt(this.items)) {
        slideControls && slideControls.classList.add("m:hidden");
      }
    }

    initSlider() {
      const { slideContainer } = queryDomNodes(this.selectors, this);
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = slideContainer.querySelector(".swiper-wrapper").childElementCount;

      slideContainer && slideContainer.classList.add("swiper-container");

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: this.products <= parseInt(this.items) ? false : true,
        pagination: this.showPagination
          ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          }
          : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1024: {
            slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        threshold: 2,
        on: {
          init: () => {
            setTimeout(() => {
              // Calculate controls position
              const firstItem = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton && prevButton.classList.remove("m:hidden");
                nextButton && nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = slideContainer && slideContainer.swiper;
    }

    getQueryString() {
      const cookieName = "minimog-recently-viewed";
      let items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
      
      // Eğer localStorage'da ürün yoksa, boş string döndür
      if (!items || items.length === 0) {
        return "";
      }
      
      const currentProductId = this.dataset.productId ? parseInt(this.dataset.productId) : null;
      
      // Mevcut ürünü listeden kaldır (kendi ürün sayfasında gösterilmemeli)
      if (currentProductId && items.includes(currentProductId)) {
        items = items.filter(item => item !== currentProductId);
      }
      
      // Eğer mevcut ürünü kaldırdıktan sonra liste boşaldıysa, boş string döndür
      if (!items || items.length === 0) {
        return "";
      }
      
      // En son bakılan ürünler önce gösterilsin
      // localStorage'da unshift ile başa ekleniyor, yani array zaten [en yeni, ..., en eski] şeklinde
      // Bu sıralama doğru, reverse etmeye gerek yok
      return items
        .map((item) => "id:" + item)
        .slice(0, this.productsToshow)
        .join(" OR ");
    }
  }
  customElements.define("m-recently-viewed", MRecentlyViewed);
}
